export const SET_EVENT_VALUE = 'DRSA/DIAGNOSIS/SET_EVENT_VALUE';
export const SET_DIAGNOSIS_VALUES = 'DRSA/DIAGNOSIS/SET_DIAGNOSIS_VALUES';

const initialState = {};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_EVENT_VALUE:
      return {
        ...state,
        event: { ...state.event, ...action.payload.event },
        eventDetails: {},
      };
    case SET_DIAGNOSIS_VALUES:
      return {
        ...state,
        event: { ...state.event, ...action.payload.event },
        eventDetails: { ...state.eventDetails, ...action.payload.eventDetails },
      };
    default:
      return state;
  }
};

export const setEventValue = ({ payload }) => ({ type: SET_EVENT_VALUE, payload });

export const storeData = ({ payload }) => ({ type: SET_DIAGNOSIS_VALUES, payload });

const actions = {
  storeData,
  setEventValue,
};

export default { reducer, actions };
